import { APPLE_PAYMENT_ERROR_TEXT, SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';
import { useSession } from 'src/hooks';
import { SubscriptionInfo } from 'src/types';
import { MinusCircle } from '@phosphor-icons/react';

type CancelSubscriptionButtonProps = {
  subscriptionInfo?: SubscriptionInfo;
  isAppleOrAmpPayment?: boolean;
  isSubscriptionInfoLoading?: boolean;
  onClick: () => void;
};

export const CancelSubscriptionButton = ({
  subscriptionInfo,
  isAppleOrAmpPayment,
  isSubscriptionInfoLoading,
  onClick,
}: CancelSubscriptionButtonProps) => {
  const { appUser } = useSession();

  const handleCancelSubscriptionClick = async () => {
    if (!subscriptionInfo) {
      return;
    }

    onClick();
  };

  const isCancelDisabled =
    isSubscriptionInfoLoading ||
    subscriptionInfo?.is_cancelled ||
    subscriptionInfo?.processing_plan_change ||
    isAppleOrAmpPayment ||
    !!appUser?.stripe_info?.renew_early_pending_subscription;

  return (
    <Button
      color="transparent"
      disabled={isCancelDisabled}
      tooltipContent={isAppleOrAmpPayment ? APPLE_PAYMENT_ERROR_TEXT : ''}
      onClick={handleCancelSubscriptionClick}
    >
      <MinusCircle size={SVG_SIZE_M} />
      <span>Cancel subscription</span>
    </Button>
  );
};
